const DEVELOPER_ROUTE_PREFIXES = [
  "/connectors",
  "/destinations",
  "/sources",
  "/transforms",
];

/**
 * Infer business vs developer mode from the current URL.
 * Returns null when the path does not imply a mode (e.g. sign-in).
 *
 * @example
 * getModeFromPathname("/business/action-items");
 * // "business"
 *
 * @example
 * getModeFromPathname("/connectors");
 * // "developer"
 *
 * @example
 * getModeFromPathname("/sources/add", "?code=abc&state=business_gmail");
 * // "business"
 */
const isBusinessOrPerformerOauthState = (state) => {
  const statePrefix = String(state || "")
    .split(".")[0]
    .replace(/_desktop2?$/, "")
    .replace(/_popup$/, "");
  return (
    statePrefix === "performer_gmail" ||
    statePrefix === "performer_drive" ||
    statePrefix === "performer_calendar" ||
    statePrefix.startsWith("business_")
  );
};

export const getModeFromPathname = (pathname, search = "") => {
  const path = String(pathname || "/");
  const params = new URLSearchParams(String(search || ""));

  const state = params.get("state") || "";
  if (params.get("code") && isBusinessOrPerformerOauthState(state)) {
    return "business";
  }

  // Keep business mode for denied/cancelled OAuth callbacks (no `code`, but `state` present).
  if (!params.get("code") && state && isBusinessOrPerformerOauthState(state)) {
    return "business";
  }

  if (path.startsWith("/business")) {
    return "business";
  }

  if (DEVELOPER_ROUTE_PREFIXES.some((prefix) => path.startsWith(prefix))) {
    return "developer";
  }

  return null;
};

/**
 * Pick the active mode: URL wins when it implies a mode, else localStorage/default.
 *
 * @example
 * resolveSelectedMode("business", "/connectors");
 * // "developer"
 *
 * @example
 * resolveSelectedMode("developer", "/");
 * // "developer"
 */
export const resolveSelectedMode = (storedMode, pathname, search = "") => {
  const urlMode = getModeFromPathname(pathname, search);
  if (urlMode) {
    return urlMode;
  }
  return storedMode === "developer" ? "developer" : "business";
};
